/**
 * Hook for connection status with toast notifications
 */

import { useEffect, useState } from 'react'
import { useLanguageStore } from '../store/languageStore'
import toast from 'react-hot-toast'

export function useConnectionStatus() {
  const { language } = useLanguageStore()
  const isRTL = language === 'ar'
  const [isOnline, setIsOnline] = useState(navigator.onLine)
  const [wasOffline, setWasOffline] = useState(false)

  useEffect(() => {
    const handleOnline = () => {
      setIsOnline(true)
      if (wasOffline) {
        toast.success(
          isRTL 
            ? '✅ تم استعادة الاتصال بالإنترنت' 
            : '✅ Internet connection restored',
          {
            duration: 4000,
            icon: '✅',
          }
        )
        setWasOffline(false)
      }
    }

    const handleOffline = () => {
      setIsOnline(false)
      setWasOffline(true)
      toast.error(
        isRTL 
          ? '⚠️ انقطع الاتصال بالإنترنت. أنت تعمل في وضع عدم الاتصال.' 
          : '⚠️ Internet connection lost. You are working offline.',
        {
          duration: 6000,
          icon: '⚠️',
        }
      )
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [isRTL, wasOffline])

  return { isOnline }
}

